import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useCitiesSelect from 'modules/cities/hooks/use-cities-select';
import useCreateNeighborhood, {
  CreateNeighborhoodProps,
  translatedCreateNeighborhoodProps,
} from 'modules/neighborhoods/hooks/use-create-neighborhood';

import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

interface Props {
  cityId?: string;
}

const CreateNeighborhood: React.FC<Props> = ({cityId}) => {
  const {getInput, getSwitch, getSelect, getPriceInput} =
    useFormInputs<CreateNeighborhoodProps>();
  const accessControls = useAccessControls();

  const {data, isLoading} = useCitiesSelect();

  return (
    <Creation<CreateNeighborhoodProps>
      {...{
        titleBar: !cityId ? {title: 'Cadastrar bairro'} : undefined,
        defaultValues: {cityId: cityId ?? accessControls.cityId, active: true},
      }}
      onSubmit={() => useCreateNeighborhood(!!cityId)}
      inputs={[
        getInput({
          name: 'name',
        }),
        getSelect({
          name: 'cityId',
          data,
          isLoading,
          hidden: () => !!cityId || !!accessControls.cityId,
        }),
        getPriceInput({name: 'deliveryPrice'}),
        getPriceInput({name: 'deliveryManFee'}),
        getSwitch({
          name: 'active',
        }),
      ]}
      translationKey={translatedCreateNeighborhoodProps}
    />
  );
};

export default CreateNeighborhood;
